import "./app/styles.css";

import { initClient } from "rwsdk/client";

initClient();
